import React, { useState, useEffect, useRef } from "react";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
  Button,
  ListGroup,
  Form,
  Toast,
  CardGroup,
} from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import Dropdown from "react-bootstrap/Dropdown";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import "../style/admin.css";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { GrCart } from "react-icons/gr";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { useContext } from "react";
import { CartContext } from "./CartContext";
import { MdOutlineHome } from "react-icons/md";
import { TiArrowBackOutline } from "react-icons/ti";
import { apibasePath } from "../config";
import { List } from "react-bootstrap-icons";
import { Fade as Hamburger } from "hamburger-react";

import { AnimatePresence, motion } from "framer-motion";
import LoadingItemsGrid from "../shared/LoadingItemsGrid";
import LoadingImg from "../shared/LoadingImg";

const MotionCol = motion.create(Col);

const Slide = () => {
  // const { cartCount } = useContext(CartContext);
  const [itemData, setItemData] = useState([]);
  const [cartCount, setCartCount] = useState([]);
  const [itemCount, setItemCount] = useState("");

  //   const [cart, setCart] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [displayData, setDisplayData] = useState([]);
  const [itemCode, setItemCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [show, setShow] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showTabSidebar, setShowTabSidebar] = useState(true);

  const [brandLogo, setBrandLogo] = useState(null);
  const [CartsCounts, setCartsCounts] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [multipleData, setMultipledata] = useState([]);

  const [AllSizes, setAllSizes] = useState([]);
  // const [maxSizes, setMaxSizes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);
  const [DeleteTag, setDeleteTag] = useState({ item_tag: "" });

  //   const handleClose = () => setShow(false);
  //   const handleShow = () => setShow(true);
  //   const [count, setcount] = useState(0);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [sizes, setSizes] = useState([]);
  const [category, setcategory] = useState();

  const [selectProduct, setSelectProduct] = useState(false);
  const [fetchedItems, setFetchedItems] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const [toast, setToast] = useState(false);
  const navigate = useNavigate();
  const [showBackButton, setShowBackButton] = useState(false);
  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const productsWithCode = {
    BL: "Bangle",
  };

  const location = useLocation();

  const [shouldApplyFilters, setShouldApplyFilters] = useState(false);

  const [filters, setFilters] = useState({
    gross_weight_min: "",
    gross_weight_max: "",
    net_weight_min: "",
    net_weight_max: "",
    stone_weight_min: "",
    stone_weight_max: "",
    size_min: "",
    size_max: "",
  });

  useEffect(() => {
    fetchCartItems();
    console.log("count saNDEEP", cartCount);
  }, []);

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;
  //    const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      // setLoading(true);
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
        // setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  const fetchdatas = async () => {
    try {
      const response = await axios.get(Api_url, {
        headers: { "Content-Type": "application/json" },
      });
      setLogo(response.data.logo);
      setName(response.data.name);
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  useEffect(() => {
    if (shouldApplyFilters) {
      applyFilters(false);
      //   handleClick()
      setShouldApplyFilters(false);
      setToast(false);
    }
  }, [filters, shouldApplyFilters]);

  useEffect(() => {
    const updatedFilters = {};

    Object.keys(filters).forEach((key) => {
      if (searchParams.has(key)) {
        updatedFilters[key] = searchParams.get(key);
      } else {
        updatedFilters[key] = "";
      }
    });
    for (const [key, val] of searchParams.entries()) {
      if (!filters[key]) {
        updatedFilters[key] = val;
      }
    }

    setFilters(updatedFilters);

    if (searchParams.has("product")) {
      setItemCode(searchParams.get("item_code"));
      setSelectProduct(true);
      // setSelectedItem(searchParams.get("product"));
      // const params = new URLSearchParams();
      setSelectedItem(
        searchParams.get("product")?.replace("%2C", ",").split(",")

        // params.set("product", selectedItem.join(","))
      );
      // handleClick({ item_code : searchParams.get('item_code') ,item_name : searchParams.get( 'product')}, false)
      console.log(searchParams.get("product"));
    } else {
      // handleClick("Products")
      // setDisplayData([]); //clearinnn if products isnt there
    }

    if (searchParams.has("size")) {
      console.log("got sizes from params");
      setAllSizes(searchParams.get("size")?.replace("%2C", ",").split(","));
      console.log(searchParams.get("size"));
      // setAllSizes(searchParams.get('size'))
      // updatedFilters.sizes =
    } else {
      setAllSizes([]);
    }

    setShouldApplyFilters(true);
  }, [location.search]);

  const Token = localStorage.getItem("token");

  useEffect(() => {
    fetchData();
    fetchdatas();
  }, [searchParams]);

  const All_Api = `${apibasePath}/client/customer-item-stock-list/`;

  const handleAllitem = async () => {
    // const Token = localStorage.getItem("token");
    // setLoading(true);
    try {
      // setLoading(true);
      const res = await axios.get(All_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("All resp[onse", res);

      // setSelectedItem("Products");

      const params = new URLSearchParams();

      if (params.has("product") || selectProduct || selectedItem?.length > 0) {
      } else {
        setItemCount(res.data.count);
        setDisplayData(res.data?.results);
      }

      // setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!searchParams.has("product")) {
      handleAllitem();
    }
  }, []);

  ///cart details
  const fetchCartItems = async () => {
    const Token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${apibasePath}/client/customer-cart-details/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("sandeep cart", response.data);
      setCartCount(response.data);

      // // assuming response.data is an array of cart items
      // const items = response.data || [];
      // setCartItems(items.map((item) => item.item_tag));
      // setCartCount(items.length);
      // setRefreshing(false);
    } catch (error) {
      console.error("Failed to fetch cart items:", error);
    }
  };

  // customer name

  const customerApi = `${apibasePath}/client/customer-name/`;

  const fetchCustomerName = async () => {
    const Token = localStorage.getItem("token");

    try {
      let response = await axios.get(customerApi, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Customer API Response:", response.data);

      if (response.data?.name) {
        setCustomerName(response.data.name); // Set name only if it exists
      } else {
        console.warn("Customer name not found in API response");
      }
    } catch (error) {
      console.error("Error fetching customer name:", error);
    }
  };

  useEffect(() => {
    fetchCustomerName(); // Call function inside useEffect
  }, []);
  // const addToCart = (product) => {
  //     setCart([...cart, product]);
  // };

  const handleClick = (item, isUserClk, event) => {
    if (item === "Products") {
      handleAllitem();
    } else {
      // fetchItemData(item);
      fetchMultipleData();
    }
    console.log(item);
    fetchMultipleData();
    // fetchItemData(item);
    fetchCartItems();
    setSelectedItem(item === "Products" ? "items" : item.item_name);

    if (item !== "Products" && isUserClk) {
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.set("product", item.item_name);
      newParams.set("item_code", item.item_code);

      setSearchParams(newParams);
    }
  };

  //scroll poition

  // const handleGoToCart = () => {
  //   localStorage.setItem("scrollPosition", window.scrollY);
  //   navigate("/add-to-cartdetails");
  // };

  // const handleNavigateToProduct = (productId) => {
  //   localStorage.setItem("scrollPosition", window.scrollY);
  //   navigate(`/customer-items/${productId}`);
  // };

  // useEffect(() => {
  //   const savedScroll = localStorage.getItem("scrollPosition");
  //   if (savedScroll && displayData.length > 0) {
  //     window.scrollTo(0, parseInt(savedScroll));
  //     localStorage.removeItem("scrollPosition");
  //   }
  // }, [displayData]);

  const scrollContainerRef = useRef(null);

  const saveScrollPosition = () => {
    if (scrollContainerRef.current) {
      localStorage.setItem(
        "containerScrollPosition",

        scrollContainerRef.current.scrollTop.toString()
      );
    }
  };

  const handleGoToCart = () => {
    saveScrollPosition();
    navigate("/add-to-cartdetails");
  };

  const handleNavigateToProduct = (productId) => {
    saveScrollPosition();
    navigate(`/customer-items/${productId}`);
  };

  // Restore scroll position when component mounts
  useEffect(() => {
    const restoreScrollPosition = () => {
      const savedPosition = localStorage.getItem("containerScrollPosition");
      if (
        savedPosition &&
        scrollContainerRef.current &&
        displayData?.length > 0
      ) {
        // Use requestAnimationFrame for smoother restoration
        requestAnimationFrame(() => {
          scrollContainerRef.current.scrollTop = parseInt(savedPosition, 10);
          localStorage.removeItem("containerScrollPosition");
        });
      }
    };

    // Add slight delay to ensure DOM is ready
    const timer = setTimeout(restoreScrollPosition, 50);
    return () => clearTimeout(timer);
  }, [displayData]);

  const Api_MultipleData = `${apibasePath}/client/customer-stock-multiple-items/`;

  const fetchMultipleData = async (item_code) => {
    const Token = localStorage.getItem("token");
    // setLoading(true);
    try {
      const response = await axios.post(
        Api_MultipleData,
        { customer_items: item_code },

        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("multiple response", response);
      setDisplayData(response.data.results);
      setItemCount(response.data.count);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching multiple data", error);
    }
  };

  useEffect(() => {
    fetchMultipleData();
  }, []);

  // const fetchItemData = async (item) => {
  //   const Token = localStorage.getItem("token");

  //   setItemCode(item.item_code);

  //   try {
  //     setLoading(true);
  //     const res = await axios.get(
  //       `${apibasePath}/client/customer-item-stock/${item.item_code}/`,
  //       {
  //         headers: {
  //           Authorization: `bearer ${Token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("bangle datas", res);

  //     setDisplayData(res?.data?.results);
  //     setSelectProduct(true);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error while getting data", error);
  //     setLoading(false);
  //   }
  // };

  const count_Api = `${apibasePath}/client/cart-count/`;

  const cartCountfeatchData = async () => {
    try {
      const response = await axios.get(count_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("carttssssscount", response?.data?.cart_count);
      setCartsCounts(response?.data?.cart_count); // Assuming response.data is an array of size values
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  console.log(selectProduct, "acaca");

  useEffect(() => {
    cartCountfeatchData();
  }, [displayData]);

  //         // console.log(queryParams.toString())

  // const applyFilters = async (isBtnClk) => {
  //   const Token = localStorage.getItem("token");

  //   try {
  //     const queryParams = new URLSearchParams();

  //     Object.entries(filters).forEach(([key, value]) => {
  //       if (value !== "") {
  //         queryParams.append(key, value);
  //       }
  //     });

  //     const url = `${apibasePath}/client/customer-stock-multiple-items/${itemCode}/?${queryParams.toString()}`;

  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `bearer ${Token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     setDisplayData(data?.results);
  //     setItemCount(data.count);

  //     if (isBtnClk) {
  //       const params = new URLSearchParams();

  //       Object.keys(filters).forEach((field) => {
  //         if (filters[field] != null && filters[field] !== "") {
  //           params.set(field, filters[field]);
  //         }
  //       });
  //       cartCountfeatchData();

  //       if (AllSizes.length > 0) {
  //         params.set("size", AllSizes.join(","));
  //       }

  //       navigate(`/mydesigns?${params.toString()}`);
  //     }
  //   } catch (error) {
  //     console.error("Error while fetching data", error);
  //   }
  // };

  const applyFilters = async (isBtnClk) => {
    const Token = localStorage.getItem("token");

    try {
      // setLoading(true);
      const queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "") {
          queryParams.append(key, value);
        }
      });

      if (AllSizes.length > 0) {
        queryParams.set("size", AllSizes.join(","));
      }

      queryParams.delete("product");

      const url = `${apibasePath}/client/customer-stock-multiple-items/?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_items: selectedItem,
        }),
      });
      //  setLoading(false)
      if (!response.ok) {
        setLoading(false);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // setLoading(true);
      const data = await response.json();
      setDisplayData(data?.results);
      setItemCount(data.count);
      // setLoading(false);
      if (isBtnClk) {
        // const params = new URLSearchParams();
        const params = searchParams;

        Object.keys(filters).forEach((field) => {
          if (filters[field] != null && filters[field] !== "") {
            params.set(field, filters[field]);
          }
        });

        if (AllSizes.length > 0) {
          params.set("size", AllSizes.join(","));
        }

        if (selectedItem?.length > 0) {
          console.log("params", params);
          setSelectProduct(true);
          params.set("product", selectedItem.join(","));
          // navigate(`/mydesigns?${params.toString()}`);
        }
        // setSearchParams(params);

        cartCountfeatchData();
        navigate(`/mydesigns?${params.toString()}`);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error while fetching filtered data", error);
    }
  };

  // Call applyFilters whenever filters change

  useEffect(() => {
    // Add a small debounce to prevent too many rapid API calls
    const debounceTimer = setTimeout(() => {
      applyFilters();
    }, 30); // 300ms delay

    return () => clearTimeout(debounceTimer);
  }, [filters, AllSizes]);

  const clearFilters = async () => {
    // setLoading(true);
    const cleared = {
      gross_weight_min: "",
      gross_weight_max: "",
      net_weight_min: "",
      net_weight_max: "",
      stone_weight_min: "",
      stone_weight_max: "",
      size: "",
    };

    setFilters(cleared);
    setAllSizes([]);
    setSelectedData([]);

    localStorage.removeItem("selectedSizes");
    Object.keys(cleared).forEach((key) => {
      localStorage.removeItem(key);
    });

    // Clear input fields directly if they exist in the DOM
    document.querySelectorAll('input[type="number"]').forEach((input) => {
      if (
        input.name === "gross_weight_min" ||
        input.name === "gross_weight_max" ||
        input.name === "net_weight_min" ||
        input.name === "net_weight_max" ||
        input.name === "stone_weight_min" ||
        input.name === "stone_weight_max"
      ) {
        input.value = "";
      }
    });

    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));

    const sizeInput = document.querySelector('input[name="size"]');
    if (sizeInput) {
      sizeInput.value = "";
    }

    // Remove "size" from URL
    const params = new URLSearchParams(window.location.search);
    params.delete("size");
    params.delete("gross_weight_min");
    params.delete("gross_weight_max");
    params.delete("net_weight_min");
    params.delete("net_weight_max");
    params.delete("stone_weight_min");
    params.delete("stone_weight_max");

    // Preserve other params like "Product", "category", etc. (optional)
    const updatedQuery = params.toString();
    const navigateTo = `/mydesigns${updatedQuery ? "?" + updatedQuery : ""}`;

    // Update URL

    // setLoading(false);
    navigate(navigateTo);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  // const handleCheckNewCheckBox = (event) => {
  //   const { value, checked, name } = event.target;

  //   if (value === "itemName") {
  //     setSelectedItem((prevSelected) => {
  //       const updatedSelection = checked
  //         ? [...prevSelected, value]
  //         : prevSelected.filter((item) => item !== value);

  //       // setMultipledata(updatedSelection);
  //       fetchMultipleData(updatedSelection);

  //       return updatedSelection;
  //     });
  //   }
  // };

  // const handleCheckNewCheckBox = (event) => {
  //   const { value, checked, name } = event.target;

  //   const params = searchParams;

  //   setSelectedItem((prevSelected) => {
  //     const updated = checked
  //       ? [...prevSelected, value] // value is item code
  //       : prevSelected.filter((item) => item !== value);

  //     fetchMultipleData(updated); // pass codes to API

  //     params.set('product', updated.join(''))

  //     return updated;
  //   });

  //     navigate(`/mydesigns?${params.toString()}`);

  //   setSearchParams(params);

  //   cartCountfeatchData();
  //   navigate(`/mydesigns?${params.toString()}`);

  // };

  //   const handleCheckNewCheckBox = (event) => {
  //     const { value, checked, name } = event.target;
  //     const params = new URLSearchParams(searchParams);
  //     setSelectedItem((prevSelected) => {
  //         const updated = checked
  //             ? [...prevSelected, value]
  //             : prevSelected.filter((item) => item !== value);

  //         if (updated.length > 0) {
  //             params.set('product', updated.join(','));
  //         } else {
  //             params.delete('product');
  //         }

  //         fetchMultipleData(updated);

  //         return updated;
  //     });

  //     setSearchParams(params);
  //     navigate(`/mydesigns?${params.toString()}`);

  //     cartCountfeatchData();
  // };

  // const handleCheckNewCheckBox = (event) => {
  //   const { value, checked, name } = event.target;
  //   const params = new URLSearchParams(searchParams);
  //   setSelectedItem((prevSelected) => {
  //     const updated = checked
  //       ? [...prevSelected, value] // value is item code
  //       : prevSelected.filter((item) => item !== value);

  //     fetchMultipleData(updated);

  //     return updated;
  //   });

  // };

  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   if (selectedItem.length > 0) {
  //     params.set('product', selectedItem.join(','));
  //   }

  //   navigate(`/mydesigns?${params.toString()}`);
  //   setSearchParams(params);

  //   cartCountfeatchData();
  // }, [selectedItem, setSearchParams, navigate, cartCountfeatchData]);

  const handleCheckNewCheckBox = async (event) => {
    const { value, checked } = event.target;

    // Immediate UI update (optimistic update)
    setSelectedItem((prevSelected) => {
      const updated = checked
        ? [...prevSelected, value]
        : prevSelected.filter((item) => item !== value);
      return updated;
    });

    try {
      const params = new URLSearchParams();
      const newSelection = checked
        ? [...selectedItem, value]
        : selectedItem.filter((item) => item !== value);

      if (newSelection.length > 0) {
        params.set("product", newSelection.join(","));
      } else {
        params.delete("product");
      }

      await Promise.all([
        fetchMultipleData(newSelection),
        cartCountfeatchData(),
        navigate(`/mydesigns?${params.toString()}`, { replace: true }),
      ]);
    } catch (error) {
      console.error("Error in checkbox handler:", error);

      setSelectedItem(selectedItem);
    }
  };

  // Simplified useEffect - might not even be needed anymore
  useEffect(() => {
    const params = new URLSearchParams();
    if (selectedItem.length > 0) {
      params.set("product", selectedItem.join(","));
    } else {
      params.delete("product");
    }
    // setSearchParams(params);
  }, [selectedItem, setSearchParams]);

  // useEffect(() => {
  //   if (itemData.length > 0) {
  //     const allItemCodes = itemData.map(item => item.item_code);
  //     setSelectedItem(allItemCodes);
  //     fetchMultipleData(allItemCodes);

  //   }
  // }, [itemData]);

  const handleCheckBoxAll = (event) => {
    const { checked } = event.target;
    console.log(event);

    if (checked) {
      // Select all item codes
      const allItemCodes = itemData.map((item) => item.item_code);
      setSelectedItem(allItemCodes);
      fetchMultipleData(allItemCodes);
    } else {
      // Deselect all
      setSelectedItem([]);
      fetchMultipleData([]);
    }
  };

  // useEffect(() => {
  //   console.log("Selected Items:", selectedItem);
  //   const params = searchParams;
  //   if (selectedItem?.length > 0) {
  //     console.log("params", params);
  //     setSelectProduct(true);
  //     params.set("product", selectedItem.join(","));
  //     setSearchParams(params);
  //     // navigate(`/mydesigns?${params.toString()}`);
  //   }
  // }, [selectedItem]);

  const handleCheckBoxChange = (event) => {
    const { name, checked, value } = event.target;
    console.log(name, checked, value);

    if (name === "size") {
      setAllSizes((prev) =>
        checked ? [...prev, value] : prev.filter((size) => size !== value)
      );
    }

    console.log(AllSizes);
  };

  useEffect(() => {
    console.log(filters);
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, []);

  const sizeApi = `${apibasePath}/client/item-available-sizes/`;
  const AllSize_Api = `${apibasePath}/client/item-available-sizes/`;
  const [maxAllSize, setMaxAllSize] = useState([]);

  useEffect(() => {
    const fetchAllSizeData = async () => {
      try {
        const response = await axios.post(AllSize_Api, {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        });
        console.log("", response);

        setMaxAllSize(response.data); // Assuming response.data is an array of size values
      } catch (error) {
        console.error("Error fetching sizes:", error);
      }
    };

    fetchAllSizeData();
  }, []);

  useEffect(() => {
    const fetchSizeData = async () => {
      if (!selectedItem) return;
      const Token = localStorage.getItem("token");
      try {
        const response = await axios.post(
          sizeApi,
          { item_codes: selectedItem },
          {
            headers: {
              Authorization: `bearer ${Token}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Sizes response", response);
        setSizes(response.data); // Assuming response.data is an array of size values
      } catch (error) {
        console.error("Error fetching sizes:", error);
      }
    };

    fetchSizeData();
  }, [selectedItem]);

  const API_URL = `${apibasePath}/client/cart/add/`;

  const { cartItems, setCartItems } = useContext(CartContext);

  const handleAddToCart = async (product) => {
    const Token = localStorage.getItem("token");
    try {
      const response = await axios.post(API_URL, product, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      const newCart = [...cartItems, product.item_tag];
      setCartItems(newCart);
      console.log("button cart list", cartItems);
      fetchCartItems();
      cartCountfeatchData();
      setLoading(false);
    } catch (error) {
      console.error("Error adding to cart", error);
      if (error.response?.status === 400) {
        if (!cartItems.includes(product.item_tag)) {
          setCartItems([...cartItems, product.item_tag]);
        }
      } else {
        alert("An error occurred while adding to cart.");
      }
    }
  };

  const Api_Delete = `${apibasePath}/client/delete-by-tag/`;

  const handleDelete = async (product) => {
    console.log("product no", product);
    const Token = localStorage.getItem("token");

    try {
      const response = await axios.delete(Api_Delete, {
        data: { item_tag: product.item_tag },
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      setDeleteTag(response.data);
      console.log("Product deleted successfully:", product);
      console.log("delete response", response);
      fetchCartItems();
      cartCountfeatchData();

      setLoading(false);
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleCartAction = async (product) => {
    console.log("cartitrfgd", cartItems);

    try {
      // const isInCart = cartItems.includes(product.item_tag);

      await handleAddToCart(product);

      setCartItems((prevItems) => [...prevItems, product.item_tag]);
    } catch (error) {
      console.error("Cart action failed:", error);
    }
  };

  const handleCartActionDelete = async (product) => {
    try {
      const isInCart = cartItems.includes(product.item_tag);

      if (isInCart) {
        await handleDelete(product);
        setCartItems((prevItems) =>
          prevItems.filter((item) => item !== product.item_tag)
        );
      }
    } catch (error) {
      console.error("Cart action failed:", error);
    }
  };

  const Api_Url = `${apibasePath}/client/customer-items/`;

  const fetchData = async () => {
    const Token = localStorage.getItem("token");

    try {
      // setLoading(true);
      const res = await axios.get(Api_Url, {
        headers: {
          Authorization: `bearer ${Token}`,
        },
      });
      setItemData(res.data);

      // setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  const [firstAllSelectDone, setFirstAllSelectDone] = useState(false);

  useEffect(() => {
    if (
      itemData?.length > 0 &&
      !searchParams.has("size") &&
      !searchParams.has("product") &&
      !firstAllSelectDone
    ) {
      // handleCheckBoxAll();
      handleCheckBoxAll({
        target: {
          checked: true,
        },
      });
      setFirstAllSelectDone(true);
    }
  }, [itemData, searchParams]);

  // useEffect(() => {
  //   // Check if there's a history to go back to.
  //   setShowBackButton(window.history.length > 1);
  // }, [window.history.length]);

  // const handleBack = () => {
  //   navigate(-1); // Navigate back one step in history
  // };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          translate: ("-50%", "-50%"),
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const Api_url = `${apibasePath}/client/profiles/company/`;

  // const handaleDropDown = () => {
  //   handleAllitem();
  //   // setSelectProduct(true);
  //   setSelectedItem("All");
  // };

  return (
    <div className="slide">
      <Navbar className="bg-body-tertiary fixed-top" expand="md">
        <Container fluid>
          <Navbar.Brand>
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={logo}
                alt="companylogo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>

          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {customerName} Shopping Cart
          </Navbar.Brand>
          {/* <Navbar.Brand style={{ color: '#23395B', fontFamily: 'Roboto', fontWeight: '600', marginRight: 'auto', fontSize: '17px' }}>
                       <a href="/mydesigns" style={{textDecoration:'none',color:'#23395B',fontfamily:'Roboto'}}>Home</a>
                    </Navbar.Brand> */}
          <div
            style={{ marginRight: "5%" }}
            className="d-flex align-items-center"
          >
            {/* {showBackButton && (
          <div style={{ marginRight: "20%" }}>
              <Navbar.Brand onClick={handleBack}
                style={{
                  color: "#23395B",
                  fontFamily: "Roboto",
                  fontWeight: "600",
                  marginRight: "auto",
                  fontSize: "17px",
                }}
              >
              <TiArrowBackOutline style={{width:'20px',height:'20px'}} />Back 
              </Navbar.Brand>
            </div>
          )} */}
            <div style={{ marginRight: "20%" }}>
              <Navbar.Brand
                className="home"
                style={{
                  color: "#23395B",
                  fontFamily: "Roboto",
                  fontWeight: "600",
                  marginRight: "auto",
                  fontSize: "17px",
                }}
              >
                <a
                  href="/mydesigns"
                  style={{
                    textDecoration: "none",
                    color: "#23395B",
                    fontfamily: "Roboto",
                  }}
                >
                  Home
                </a>
              </Navbar.Brand>
            </div>
            <Button
              variant="outline-light"
              className="d-md-none"
              onClick={handleSidebarShow}
            >
              <RxHamburgerMenu
                className="hamsburg"
                style={{
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                  color: "#000",
                  marginLeft: "10%",
                }}
              />
            </Button>

            <Navbar.Brand className="cart">
              <a
                href=""
                onClick={handleGoToCart}
                style={{ position: "relative" }}
              >
                <GrCart
                  style={{ width: "30px", height: "30px", color: "#396D72" }}
                />

                {CartsCounts > 0 && ( // Only show the count if it's greater than 0
                  <span
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "4px 7px",
                      fontSize: "12px",
                    }}
                  >
                    <h1 style={{ fontSize: "12px", margin: 0 }}>
                      {CartsCounts}
                    </h1>
                  </span>
                )}
              </a>
            </Navbar.Brand>
          </div>
        </Container>
      </Navbar>

      <Container fluid>
        <Row>
          {/* Sidebar - Always visible on larger screens, collapsible on mobile */}
          <AnimatePresence mode="wait" key={showTabSidebar}>

         
          {/* {showTabSidebar && ( */}
            <MotionCol
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: showTabSidebar ? 1:0, width: showTabSidebar ? '25%':'0%' }}
              exit={{ x: -300, opacity: 0 }}
              layout
              
              md={3}
              className="p-3 d-none d-md-block  "
              style={{
                backgroundColor: "#396D72",
                height: "calc(100vh - 70px)",
                marginTop: "70px",
                // position:'fixed',
                overflowY: "auto",
                position: "sticky",
                top: "70px",
                // border: "1px solid red",
                // display: showTabSidebar ? "block" : "none",
              }}
            >
              <div
                style={{
                  // backgroundColor: "#396D72",
                  border: "none",
                  // fontSize: "20px",
                  color: "#fff",
                  marginLeft: "30px",
                  fontFamily: "Roboto",
                }}
              >
                <div
                  style={{
                    border: "none",
                    fontSize: "20px",
                    color: "#fff",
                    // marginLeft: "30px",
                    fontFamily: "Roboto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "16px 0",
                  }}
                >
                  <span>Products</span>

                  {/* <List /> */}
                  {/* <Hamburger toggled={showTabSidebar} onToggle={() => { 
                  setTimeout(()=> {setShowTabSidebar(prev => !prev)},1000)  }}  direction="right" size={20} /> */}
                </div>
                <Form.Check
                  type="checkbox"
                  onChange={handleCheckBoxAll}
                  checked={
                    selectedItem.length === itemData.length &&
                    itemData.length > 0
                  }
                  value=""
                  id="checkbox"
                  label="Select All Products"
                  htmlFor="checkbox"
                  className="mb-2 transparent-checkbox"
                  onClick={(e) => e.stopPropagation()}
                  style={{ cursor: "pointer" }}
                />

                {itemData.map((item, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    onChange={(e) => {
                      handleCheckNewCheckBox(e);
                    }}
                    checked={selectedItem.includes(item.item_code)}
                    name="itemName"
                    id={`item-name-${index}`}
                    value={item.item_code}
                    label={item.item_name}
                    htmlFor={`item-name-${index}`}
                    className="mb-2 transparent-checkbox"
                    onClick={(e) => e.stopPropagation()}
                  />
                ))}
              </div>
              {/* filters */}

              {/* <div>
              <Form style={{ paddingTop: "20px", marginLeft: "30px" }}>
                
                <Form.Group>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Size
                  </Form.Label>{" "}
                  <br />
                  <div
                    className="checks"
                    style={{
                      display: "flex",
                      color: "#fff",
                      justifyContent: "space-between",
                      backgroundColor: "transparent",
                    }}
                  >
                    <div
                      className="row"
                      style={{
                        marginLeft: "2px",
                      }}
                    >
                      {sizes.map((size, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          onChange={handleCheckBoxChange}
                          checked={AllSizes.includes(`${size}`)}
                          name="size"
                          id={`size-checkbox-${index}`}
                          value={size}
                          label={size}
                          htmlFor={`size-checkbox-${index}`}
                          className="mb-2 transparent-checkbox col-4"
                        />
                      ))}
                    </div>
                  </div>
                </Form.Group>

       
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Gross Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="gross_weight_min"
                      placeholder="Min"
                      value={filters.gross_weight_min}
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <Form.Control
                      type="number"
                      name="gross_weight_max"
                      value={filters.gross_weight_max}
                      placeholder="Max"
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Net Weight
                  </Form.Label>
                  <div style={{ display: "flex", marginTop: "3px" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="net_weight_min"
                      placeholder="Min"
                      value={filters.net_weight_min}
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <Form.Control
                      type="number"
                      name="net_weight_max"
                      placeholder="Max"
                      value={filters.net_weight_max}
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

           
                <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                  <Form.Label
                    style={{
                      color: "#fff",
                      fontfamily: "Roboto",
                      fontWeight: "500",
                      lineHeight: "1.2",
                      letterSpacing: "0",
                      fontSize: "20px",
                    }}
                  >
                    Stone Weight
                  </Form.Label>
                  <div style={{ display: "flex" }}>
                    <Form.Control
                      type="number"
                      style={{
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                      name="stone_weight_min"
                      placeholder="Min"
                      value={filters.stone_weight_min}
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <Form.Control
                      type="number"
                      name="stone_weight_max"
                      placeholder="Max"
                      value={filters.stone_weight_max}
                      onChange={handleInputChange}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        // Optional: Prevent arrow keys from changing the value
                        if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      style={{
                        marginLeft: "10px",
                        backgroundColor: "transparent",
                        color: "#fff",
                        borderRadius: "3px",
                      }}
                    />
                  </div>
                </Form.Group>

              
                <div
                  align="center"
                  className="apply_button"
                  style={{ marginTop: "50px" }}
                >
                  <div>
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant="light"
                      onClick={() => applyFilters(true)}
                    >
                      Apply Filters
                    </Button>

                    {toast && (
                      <Toast
                        className="d-inline-block m-1 position-fixed  end-0"
                        bg="danger"
                        onClose={() => setToast(false)}
                        delay={7000}
                        autohide
                        style={{ top: "90px", marginRight: "10px" }} // Added margin-top and margin-right
                      >
                        <Toast.Header>
                          
                        </Toast.Header>
                        <Toast.Body style={{ color: "#fff", fontSize: "15px" }}>
                          Please select Product
                        </Toast.Body>{" "}
                     
                      </Toast>
                    )}
                  </div>
         

                  <Button
                    style={{
                      backgroundColor: "#fff",
                      color: "#23395B",
                      boxShadow: "0px 0px 7px 0px #000",
                      border: "none",
                    }}
                    className="pe-4 ps-4 mt-4 me-4"
                    variant="light"
                    onClick={clearFilters}
                  >
                    Clear Filters
                  </Button>
                
                </div>
              </Form>


            </div> */}

              <div>
                <Form style={{ paddingTop: "20px", marginLeft: "30px" }}>
                  {/* Size checkboxes */}
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Size
                    </Form.Label>{" "}
                    <br />
                    <div
                      className="checks"
                      style={{
                        display: "flex",
                        color: "#fff",
                        justifyContent: "space-between",
                        backgroundColor: "transparent",
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          marginLeft: "2px",
                        }}
                      >
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            checked={AllSizes.includes(`${size}`)}
                            name="size"
                            id={`size-checkbox-${index}`}
                            value={size}
                            label={size}
                            htmlFor={`size-checkbox-${index}`}
                            className="mb-2 transparent-checkbox col-4"
                          />
                        ))}
                      </div>
                    </div>
                  </Form.Group>

                  {/* Gross Weight */}
                  <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Gross Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                        name="gross_weight_min"
                        placeholder="Min"
                        value={filters.gross_weight_min}
                        onChange={handleInputChange}
                        onBlur={applyFilters}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }

                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="gross_weight_max"
                        value={filters.gross_weight_max}
                        placeholder="Max"
                        onChange={handleInputChange}
                        onBlur={applyFilters} // Trigger when field loses focus
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                          // Trigger on Enter key
                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Net Weight */}
                  <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Net Weight
                    </Form.Label>
                    <div style={{ display: "flex", marginTop: "3px" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                        name="net_weight_min"
                        placeholder="Min"
                        value={filters.net_weight_min}
                        onChange={handleInputChange}
                        onBlur={applyFilters} // Trigger when field loses focus
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="net_weight_max"
                        placeholder="Max"
                        value={filters.net_weight_max}
                        onChange={handleInputChange}
                        onBlur={applyFilters} // Trigger when field loses focus
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Stone Weight */}
                  <Form.Group style={{ paddingTop: "10px", marginTop: "20px" }}>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Stone Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                        name="stone_weight_min"
                        placeholder="Min"
                        value={filters.stone_weight_min}
                        onChange={handleInputChange}
                        onBlur={applyFilters} // Trigger when field loses focus
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="stone_weight_max"
                        placeholder="Max"
                        value={filters.stone_weight_max}
                        onChange={handleInputChange}
                        onBlur={applyFilters} // Trigger when field loses focus
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                          if (e.key === "Enter") {
                            applyFilters();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                          borderRadius: "3px",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Only keep the Clear Filters button */}
                  <div
                    align="center"
                    className="apply_button"
                    style={{ marginTop: "50px" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant="light"
                      onClick={clearFilters}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </Form>
              </div>
            </MotionCol>
          {/* )} */}
         

          {/* Offcanvas Sidebar for Mobile */}
          <Offcanvas
            show={showSidebar}
            onHide={handleSidebarClose}
            placement="start"
          >
            <Offcanvas.Header
              className="custom-offcanvas-header"
              variant="light"
              closeButton
              style={{ backgroundColor: "#396D72", color: "#fff" }}
            >
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ backgroundColor: "#396D72" }}>
              <div
                style={{
                  // backgroundColor: "#396D72",
                  border: "none",
                  // fontSize: "20px",
                  color: "#fff",
                  marginLeft: "30px",
                  fontFamily: "Roboto",
                }}
              >
                <div
                  style={{
                    border: "none",
                    fontSize: "20px",
                    color: "#fff",
                    // marginLeft: "30px",
                    fontFamily: "Roboto",
                  }}
                >
                  <p>Products</p>
                </div>
                <Form.Check
                  type="checkbox"
                  onChange={handleCheckBoxAll}
                  checked={
                    selectedItem.length === itemData.length &&
                    itemData.length > 0
                  }
                  value=""
                  id="checkbox"
                  label="Select All Products"
                  htmlFor="checkbox"
                  className="mb-2 transparent-checkbox"
                  onClick={(e) => e.stopPropagation()}
                  style={{ cursor: "pointer" }}
                />

                {itemData.map((item, index) => (
                  <Form.Check
                    key={index}
                    type="checkbox"
                    onChange={(e) => {
                      handleCheckNewCheckBox(e);
                    }}
                    checked={selectedItem.includes(item.item_code)}
                    name="itemName"
                    id={`item-name-${index}`}
                    value={item.item_code}
                    label={item.item_name}
                    htmlFor={`item-name-${index}`}
                    className="mb-2 transparent-checkbox"
                    onClick={(e) => e.stopPropagation()}
                  />
                ))}
              </div>

              {/* <div align="end">
                <Navbar.Brand className="">
                  <a
                    href=""
                    onClick={handleGoToCart}
                    style={{ position: "relative" }}
                  >
                    <GrCart
                      style={{ width: "30px", height: "30px", color: "white" }}
                    />

                    {CartsCounts > 0 && ( // Only show the count if it's greater than 0
                      <span
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: "50%",
                          padding: "4px 7px",
                          fontSize: "12px",
                        }}
                      >
                        <h1 style={{ fontSize: "12px", margin: 0 }}>
                          {CartsCounts}
                        </h1>
                      </span>
                    )}
                  </a>
                </Navbar.Brand>
              </div> */}

              {/* filters */}
              <div>
                <Form style={{ paddingTop: "20px" }}>
                  {/* <Form.Label style={{ color: '#fff', fontSize: '30px', fontFamily: 'Poppins', textDecoration: "underline" }}>Apply Filters</Form.Label> */}
                  <Form.Group>
                    <Form.Label
                      style={{
                        color: "#fff",
                        fontfamily: "Roboto",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        letterSpacing: "0",
                        fontSize: "20px",
                      }}
                    >
                      Size
                    </Form.Label>{" "}
                    <br />
                    <div
                      className="checks"
                      style={{
                        display: "flex",
                        color: "#fff",
                        justifyContent: "space-between",
                        backgroundColor: "transparent",
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          marginLeft: "2px",
                        }}
                      >
                        {sizes.map((size, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            checked={AllSizes.includes(`${size}`)}
                            name="size"
                            id={`size-checkbox-${index}`}
                            htmlFor={`size-checkbox-${index}`}
                            value={size}
                            label={size}
                            className="mb-2 transparent-checkbox col-4"
                          />
                        ))}
                      </div>
                    </div>
                  </Form.Group>
                  {/* Gross Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Gross Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="gross_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="gross_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Net Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Net Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        type="number"
                        name="net_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="net_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Stone Weight */}
                  <Form.Group style={{ paddingTop: "10px" }}>
                    <Form.Label
                      style={{
                        color: "white",
                        fontSize: "20px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Stone Weight
                    </Form.Label>
                    <div style={{ display: "flex" }}>
                      <Form.Control
                        type="number"
                        style={{
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                        name="stone_weight_min"
                        placeholder="Min"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Form.Control
                        type="number"
                        name="stone_weight_max"
                        placeholder="Max"
                        onChange={handleInputChange}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => {
                          // Optional: Prevent arrow keys from changing the value
                          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        style={{
                          marginLeft: "10px",
                          backgroundColor: "transparent",
                          color: "#fff",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Apply Filters Button */}
                  <div
                    align="center"
                    style={{ marginTop: "50px" }}
                    className=""
                  >
                    <div>
                      <Button
                        style={{
                          backgroundColor: "#fff",
                          color: "#23395B",
                          boxShadow: "0px 0px 7px 0px #000",
                          border: "none",
                        }}
                        className="pe-4 ps-4 mt-4 me-4"
                        variant="light"
                        onClick={() => applyFilters(true)}
                      >
                        Apply Filters
                      </Button>

                      {toast && (
                        <Toast
                          className="d-inline-block m-1 position-fixed  end-0"
                          bg="success"
                          onClose={() => setToast(false)}
                          delay={3000}
                          autohide
                          style={{ top: "90px", marginRight: "10px" }} // Added margin-top and margin-right
                        >
                          <Toast.Header>
                            <strong className="me-auto">Notice</strong>
                          </Toast.Header>
                          <Toast.Body style={{ color: "#fff" }}>
                            Please select Product
                          </Toast.Body>{" "}
                          {/* Added inline style for text color */}
                        </Toast>
                      )}
                    </div>
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        color: "#23395B",
                        boxShadow: "0px 0px 7px 0px #000",
                        border: "none",
                      }}
                      className="pe-4 ps-4 mt-4 me-4"
                      variant="light"
                      onClick={clearFilters}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* //product items */}

 

          <MotionCol
           
      initial={{
        x: showTabSidebar ? 20 : 0,
        // opacity: 0,
        // width: showTabSidebar ? "75%" : "100%", // avoids jump at mount
      }}
      animate={{
        x: 0,
        width: showTabSidebar ? "75%" : "100%",
      }}
      exit={{
        x:showTabSidebar ? 20 : 0,
        // opacity: 0,
      }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      style={{ flexGrow: 1, marginTop: "100px" }}
            // md={showTabSidebar ? 9 : 12}
            className="scrollable-content  "
          
          >
            {/* {!showTabSidebar && */}
            <div
              className="d-none d-md-block  "
              style={{
                position: "fixed",
                top: "95px",
                left: showTabSidebar ? "18%" : "10px",
                // right: showTabSidebar ? "100px" : "inherit",
                zIndex:50

              }}
            >
              <Hamburger
                color={showTabSidebar ? "#FFF" : "#000"}
                toggled={showTabSidebar}
                onToggle={() => {
                  setShowTabSidebar((prev) => !prev);
                }}
                direction="right"
                size={20}
              />
            </div>
            {/* } */}

            <div
              className="cart_items"
              style={{ marginLeft: "2%", marginTop: "50px" }}
            >
              <text style={{ color: "#000" }}>items : {itemCount}</text>
            </div>

            {/* <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                marginTop: "70px",
                gap: "10px",
              }}
            >
              {displayData && displayData.length > 0 ? (
                displayData.map((product) => (
                  <Card
                    style={{
                      width: "18rem",
                      height: "30rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      borderRadius: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        onClick={() => handleNavigateToProduct(product.id)}
                        variant="top"
                        src={
                          product.image ? product.image : "./images/noimage.jpg"
                        }
                        onContextMenu={handleContextMenu}
                        style={{
                          width: "100%",
                          height: "100%",

                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    <Card.Body
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flexGrow: 1,
                      }}
                    >
                      <div align="center">
                        <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "0",
                            letterSpacing: "0",
                          }}
                        >
                          {product.item_tag}
                        </p>
                        <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "1",
                            letterSpacing: "0",
                          }}
                        >
                          {product.item_name}
                        </p>
                      </div>
                      <Card.Text
                        style={{ marginTop: "10px", marginLeft: "25%" }}
                      >
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Gross Wt&nbsp; :{" "}
                          {product.gross_weight % 1 === 0
                            ? product.gross_weight
                            : Number(product.gross_weight).toFixed(3) ||
                              "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                          {product.net_weight % 1 === 0
                            ? product.net_weight
                            : Number(product.net_weight).toFixed(3) ||
                              "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Stone Wt&nbsp; :{" "}
                          {product.stone_weight % 1 === 0
                            ? product.stone_weight
                            : Number(product.stone_weight).toFixed(3) ||
                              "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                          {product.size || "N/A"}
                        </p>
                      </Card.Text>
                    </Card.Body>
                    
                    <Button
                      variant="primary"
                      className="w-100 mt-2"
                      style={{
                        backgroundColor: cartItems.includes(product.item_tag)
                          ? "#396D72"
                          : "#D1B457",
                        border: "none",
                        borderBottomLeftRadius: "13px",
                        borderBottomRightRadius: "13px",
                        borderTopRightRadius: "0",
                        borderTopLeftRadius: "0",
                      }}
                      onClick={() => handleCartAction(product)}
                    >
                      {cartItems.includes(product.item_tag) ? (
                        <span style={{ marginLeft: "15%" }}>
                          Added to Cart{" "}
                          <Button
                            className=""
                            style={{
                              marginLeft: "28%",
                              paddingBottom: "1px",
                              paddingTop: "1px",
                              backgroundColor: "transparent",
                              border: "0",
                            }}
                            onClick={() => handleCartActionDelete(product)}
                          >
                            {" "}
                            <MdDelete />
                          </Button>
                        </span>
                      ) : (
                        "Add to Cart"
                      )}
                    </Button>
                  </Card>
                ))
              ) : (
                <Col className="text-centere">
                  <p
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      alignItems: "center",
                    }}
                  >
                    No Item found
                  </p>
                </Col>
              )}
            </div> */}
            <div
              ref={scrollContainerRef}
              style={{
                height: "calc(250vh - 150px)",
                overflowY: "auto",
                scrollBehavior: "smooth",
              }}
            >
              <Row className="g-2   mt-3">
                {displayData && displayData.length > 0 ? (
                  displayData.map((product, index) => (
                    <Col xs={6} sm={6} md={4} lg={3} key={index}>
                      <Card
                        className="h-100"
                        style={{
                          borderRadius: "15px",
                          overflow: "hidden",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          {/* <img
                            src={product.image || "./images/noimage.jpg"}
                            alt={product.item_name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            
                            onClick={() => handleNavigateToProduct(product.id)}
                            onContextMenu={handleContextMenu}
                          /> */}
                          <LoadingImg product={product} handleNavigateToProduct={() => {handleNavigateToProduct(product.id)}} onContextMenu={handleContextMenu}/>
                        </div>

                        <Card.Body>
                          <div align="center">
                            <h6
                              className="mb-1"
                              style={{
                                fontWeight: "600",
                                fontFamily: "Roboto",
                              }}
                            >
                              {product.item_tag}
                            </h6>
                            <p
                              className="mb-1"
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                fontFamily: "Roboto",
                              }}
                            >
                              {product.item_name}
                            </p>
                          </div>
                          <div
                            className="cart_weight"
                            style={{
                              fontSize: "13px",
                              fontFamily: "Roboto",
                              fontWeight: "400",
                            }}
                          >
                            <p style={{ margin: "0" }}>
                              Gross Wt&nbsp; :{" "}
                              {product.gross_weight % 1 === 0
                                ? product.gross_weight
                                : Number(product.gross_weight).toFixed(3) ||
                                  "N/A"}{" "}
                              gm
                            </p>
                            <p style={{ margin: "0" }}>
                              Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                              {product.net_weight % 1 === 0
                                ? product.net_weight
                                : Number(product.net_weight).toFixed(3) ||
                                  "N/A"}{" "}
                              gm
                            </p>
                            <p style={{ margin: "0" }}>
                              Stone Wt&nbsp; :{" "}
                              {product.stone_weight % 1 === 0
                                ? product.stone_weight
                                : Number(product.stone_weight).toFixed(3) ||
                                  "N/A"}{" "}
                              gm
                            </p>
                            <p style={{ margin: "0" }}>
                              {" "}
                              Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                              {product.size || "N/A"}
                            </p>
                          </div>
                        </Card.Body>

                        <Button
                          variant="primary"
                          className="w-100"
                          style={{
                            backgroundColor: cartItems.includes(
                              product.item_tag
                            )
                              ? "#396D72"
                              : "#D1B457",
                            border: "none",
                            borderRadius: "0 0 15px 15px",
                          }}
                          onClick={() => handleCartAction(product)}
                        >
                          {cartItems.includes(product.item_tag) ? (
                            <>
                              Added to Cart
                              <Button
                                className="Add_cart"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  paddingLeft: "10px",
                                  paddingTop: "0px",
                                  paddingBottom: "0px",
                                  // marginLeft:'10%'
                                  alignItems: "center",
                                }}
                                onClick={() => handleCartActionDelete(product)}
                              >
                                <MdDelete />
                              </Button>
                            </>
                          ) : (
                            "Add to Cart"
                          )}
                        </Button>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <LoadingItemsGrid />
                )}
              </Row>
            </div>
          </MotionCol>
          </AnimatePresence>    
        </Row>
      </Container>

      <hr style={{ border: "1px solid #000000" }} />

      <div
        className="address"
        style={{
          // marginLeft: "auto",
          // marginRight: "auto",
          marginTop: "30px",
          // borderTop: "1px solid",
          fontFamily: "Roboto",
          fontWeight: "500",
          maxWidth: "600px", // Limit the width for better readability on larger screens
          padding: "0 20px", // Add padding for smaller screens
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "30px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Shubham Jewellers
          </h3>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              marginTop: "20px",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Address
          </h2>
          <p style={{ fontSize: "12px", marginTop: "20px" }}>
            Sri Shubham Jewellery, 2nd <br /> floor 201/202, mayur kushal <br />{" "}
            complex abids, Gunfoundry, <br /> Hyderabad 500001, Telegana, <br />{" "}
            India
          </p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Phone
          </h2>
          <p style={{ fontSize: "12px", marginTop: "20px" }}>+919949946000</p>
        </div>
        <div>
          <h2
            style={{
              fontSize: "20px",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "1",
              letterSpacing: "0",
            }}
          >
            Email
          </h2>
          <p style={{ fontSize: "12px", marginTop: "20px" }}>
            srishubhamjewellers@gmail.com
          </p>
        </div>
      </div>
      <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px", //add some space between text and logo
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide;
